var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWellness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 98 76.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7118",
    x: 0,
    y: 0,
    width: 98,
    height: 76.555,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wellness",
    transform: "translate(9 -50.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238",
    transform: "translate(0 56.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_7118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7118-2",
    "data-name": "Path 7118",
    d: "M78.631,84.461H71.863c2.814-6.388,2.51-11.559,1.445-15.057-1.825-6.236-7.985-13-17.11-13a21.393,21.393,0,0,0-7.376,1.369A38.259,38.259,0,0,0,40.3,62.027a36.511,36.511,0,0,0-8.517-4.259A21.72,21.72,0,0,0,24.411,56.4c-9.125,0-15.285,6.768-17.11,13C6.236,73.13,5.856,78.757,9.43,85.83H1.217a1.217,1.217,0,0,0,0,2.433h9.658a16.053,16.053,0,0,0,1.369,2.053c7.909,11.407,25.1,23.8,28.213,24.563v.076a.236.236,0,0,0,.152-.076h.228V114.8C43.5,113.51,60,102.864,68.669,90.24A27.977,27.977,0,0,0,70.8,86.818h7.985A1.2,1.2,0,0,0,80,85.6,1.278,1.278,0,0,0,78.631,84.461ZM66.464,88.948C58.4,100.735,43.574,110.24,40.38,112.294c-3.27-2.053-18.023-11.635-26.16-23.346l-.456-.684H24.943a1.255,1.255,0,0,0,1.141-.684l5.1-10.038L39.164,98a1.245,1.245,0,0,0,1.141.76h.076a1.211,1.211,0,0,0,1.141-.913l7-23.954,3.726,12.091a1.24,1.24,0,0,0,.989.837,1.317,1.317,0,0,0,1.217-.532l2.966-4.335,2.51,4.259a1.214,1.214,0,0,0,1.065.608h6.844C67.376,87.579,66.92,88.263,66.464,88.948ZM69.2,84.461H61.749l-3.118-5.323a1.214,1.214,0,0,0-1.065-.608,1.151,1.151,0,0,0-1.065.532l-2.586,3.8L49.734,69.252a1.411,1.411,0,0,0-1.217-.913,1.3,1.3,0,0,0-1.217.913L40.228,93.662l-7.681-19.62a1.144,1.144,0,0,0-1.065-.76,1.179,1.179,0,0,0-1.141.684L24.335,85.754H12.243C9.2,80.2,8.365,74.879,9.734,70.088A15.536,15.536,0,0,1,24.487,58.91a20.23,20.23,0,0,1,6.54,1.217,36.969,36.969,0,0,1,8.593,4.411,1.157,1.157,0,0,0,1.521,0,33.154,33.154,0,0,1,8.593-4.411,18.384,18.384,0,0,1,6.54-1.217A15.611,15.611,0,0,1,71.027,70.088C72.319,74.5,71.635,79.366,69.2,84.461Z",
    transform: "translate(9 -50.4)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellness);
export default __webpack_public_path__ + "static/media/Wellness.fa892316d797c5b9d9bd2f9c24dc4685.svg";
export { ForwardRef as ReactComponent };